import { CloudStorageProviders } from 'src/utilities/cloud-storage/providers';

function getIcon(id) {
	return CloudStorageProviders.find(p => p.id === id)?.icon;
}

export default {
	'esignatures': {
		title: 'Electronic Signatures',
		description: 'Go paperless and collect signatures on every form and on any device.',
		featureCode: 'electsig',
		illustration: 'electronic-signatures',
		plan: 'pro'
	},
	'folders': {
		title: 'Folders',
		description: 'Create folders to organize your forms.',
		featureCode: 'folders',
		illustration: 'folders',
		plan: 'pro'
	},
	'saveandresume': {
		title: 'Save & Resume',
		description: 'Allow users to pick up right where they left off by saving their progress on partially completed form responses.',
		featureCode: 'saveresu',
		illustration: 'save-resume',
		plan: 'pro'
	},
	'tables': {
		title: 'Table Field',
		description: 'Collect and summarize data in a compact grid with rows that repeat and expand as needed.',
		featureCode: 'table',
		illustration: 'table',
		plan: 'pro'
	},
	'lookups': {
		title: 'Lookup Fields',
		description: 'Connect your entry data from other forms to populate dropdowns, perform calculations, or display text.',
		featureCode: 'lookup',
		illustration: 'lookup-field',
		plan: 'team'
	},
	'personfields': {
		title: 'Person Fields',
		description: 'Simplify user and task assignments for employees, clients, volunteers, or anyone involved in your workflow processes.',
		featureCode: 'personfields',
		illustration: 'person-field',
		plan: 'team'
	},
	'passwordfields': {
		title: 'Password Fields',
		description: 'Securely collect passwords and other sensitive credentials using masked input fields.',
		featureCode: 'passwordfields',
		illustration: 'security',
		plan: 'team'
	},
	'importentriesfeature': {
		title: 'Import Entry Data',
		description: 'Upload or update your entry data in bulk and manage all of your data in one place.',
		featureCode: 'import',
		illustration: 'import-form-entries',
		plan: 'pro'
	},
	'entrysharing': {
		title: 'Entry Sharing',
		description: 'Share your entries and easily customize when and where entry links are sent.',
		featureCode: 'entrysharing',
		illustration: 'entry-sharing',
		plan: 'pro'
	},
	'emailrouting': {
		title: 'Multiple Email Notifications',
		description: 'Create additional email notifications, so you can route emails to the right people at the right time.',
		featureCode: 'addiemai',
		illustration: 'email-notifications',
		plan: 'pro'
	},
	'fileattachments': {
		title: 'Email Attachments',
		description: 'Include uploaded files as attachments when sending custom email notifications.',
		featureCode: 'emailattachments',
		illustration: 'file-uploads',
		plan: 'pro'
	},
	'encryptentries': {
		title: 'Data Encryption',
		description: 'Ensure your data is at the highest level of protection by encrypting your data when collecting sensitive information.',
		featureCode: 'encryption',
		illustration: 'data-encryption',
		plan: 'team',
		checkoutPlan: 'Team',
		shortTitle: false,
		videoId: 'Jg3SbsNdM6M'
	},
	'analyticsandtracking': {
		title: 'Analytics & Tracking',
		description: 'Gain insights on your users and make smarter advertising decisions by using your data to measure success.',
		featureCode: 'analytics',
		illustration: 'analytics-tracking',
		plan: 'pro'
	},
	'savecustomercard': {
		title: 'Card on File',
		description: 'Securely store customer credit and debit cards for future use - while staying PCI compliant.',
		featureCode: 'cardonfile',
		illustration: 'card-on-file',
		plan: 'team'
	},
	'users': {
		title: 'Additional Users',
		description: 'Make for easy collaboration by increasing the users that have access to your organization and forms.',
		featureCode: 'users',
		illustration: 'account-organization',
		plan: 'pro',
		priority: true
	},
	'require2fa': {
		title: 'Require Two-Factor Authentication',
		description: 'Increase data security by requiring all users in an organization to use 2FA when accessing Cognito Forms.',
		featureCode: '2fa',
		illustration: '2fa',
		plan: 'enterprise'
	},
	'bulkfiledownload': {
		title: 'Bulk File Downloads',
		description: 'Download all (or a selection of) files collected on your form into a convenient Zip file.',
		featureCode: 'bulkfiledownload',
		illustration: 'bulk-file-downloads',
		plan: 'pro'
	},
	'bulkdocumentdownload': {
		title: 'Bulk Document Downloads',
		description: 'Quickly download documents generated from your entry data into a convenient Zip file.',
		featureCode: 'bulkdocumentdownload',
		illustration: 'bulk-file-downloads',
		plan: 'pro',
		checkoutPlan: 'Pro',
		shortTitle: true,
		videoId: 'Txgr5hR18h0'
	},
	'storagelimits': {
		title: 'Storage Limits',
		description: 'Your organization is currently exceeding the storage capacity allowed for your selected plan.',
		featureCode: 'storagelimits',
		illustration: 'limit-exceeded',
		plan: null
	},
	'entrylimits': {
		title: 'Entry Limits',
		description: 'Your organization has exceeded the number of new entries allowed for your selected plan for the month.',
		featureCode: 'entrylimits',
		illustration: 'limit-exceeded',
		plan: null
	},
	'posttoendpoint': {
		title: 'JSON Webhooks',
		description: 'Transfer your data via JSON webhooks whenever an entry is submitted, updated or deleted.',
		featureCode: 'webhooks',
		illustration: 'webhooks',
		plan: 'pro'
	},
	'entryviews': {
		title: 'Saved Entry Views',
		description: 'Save and organize custom views of your entries for quick access anytime.',
		featureCode: 'entryview',
		illustration: 'entry-management',
		plan: 'pro',
		checkoutPlan: 'Pro',
		shortTitle: false,
		videoId: 'E_uVSkfjTs8'
	},
	'entryviewsexist': {
		title: 'Saved Entry Views',
		description: 'Dealing with a high volume of data? Manage, sort, and filter your entries like a pro with custom entry views.',
		featureCode: 'entryview',
		illustration: 'entry-management',
		plan: 'pro',
		checkoutPlan: 'Pro',
		shortTitle: false,
		videoId: 'E_uVSkfjTs8'
	},
	'paypal': {
		title: 'PayPal Payments',
		description: 'Accept PayPal payments and process credit cards on your order forms, donation forms and more.',
		featureCode: 'paypal',
		illustration: 'payment',
		plan: 'team'
	},
	'square': {
		title: 'Square Payments',
		description: 'Build online order forms to grow your business and sell faster with Square.',
		featureCode: 'square',
		illustration: 'payment',
		plan: 'team'
	},
	'folderpermissions': {
		title: 'Folder Permissions',
		description: 'Assign permissions to all forms in a folder with a single click.',
		featureCode: 'folderperm',
		illustration: 'folders',
		plan: 'enterprise'
	},
	'workflowlinkspro': {
		title: 'Workflow Links',
		description: '<p>Upgrade now to unlock the full potential of sharing entries with role-based links to create flexible workflows.</p> <br> <p>As an existing Pro customer, you can continue to share Public and Reviewer links (formerly Edit and View links) but cannot customize these roles or form read-only settings.</p>',
		featureCode: 'workflowlinks',
		illustration: 'workflow',
		plan: 'team',
		rawHtml: true,
		checkoutPlan: 'Team',
		shortTitle: false,
		videoId: 'Q9Ykz_17siU'
	},
	'workflowlinks': {
		title: 'Workflow Links',
		description: 'Allow anyone to participate in flexible workflows by sharing role-based links to your entries.',
		featureCode: 'workflowlinks',
		illustration: 'workflow',
		plan: 'team',
		checkoutPlan: 'Team',
		shortTitle: false,
		videoId: 'Q9Ykz_17siU'
	},
	'bulkactions': {
		title: 'Bulk Actions',
		description: 'Perform workflow actions for multiple entries all at once.',
		featureCode: 'bulkactions',
		illustration: 'actions',
		plan: 'pro'
	},
	'entryauditing': {
		title: 'Entry Auditing',
		description: 'Know the history of your entries.  View who made changes, when they happened, and what the outcomes were.',
		featureCode: 'entryauditing',
		illustration: 'activity-log',
		plan: null
	},
	'requiresso': {
		title: 'Require Single Sign-On',
		description: '<p>Simplify onboarding and enhance security by requiring all organization members to use SSO authentication when accessing Cognito&nbsp;Forms.</p>',
		featureCode: 'requiresso',
		illustration: 'sso',
		plan: 'enterprise',
		rawHtml: true
	},
	'tasks': {
		title: 'Workflow Tasks',
		description: '<p>Elevate your workflow with the ability to turn form entries into user&#8209;specific tasks. Users can easily view and complete all of their assigned tasks as your form moves from one status to the&nbsp;next.</p>',
		featureCode: 'workflowtasks',
		illustration: 'tasks',
		plan: 'team',
		rawHtml: true,
		checkoutPlan: 'Team',
		shortTitle: false,
		videoId: '_uOBbrYl88c'
	},
	'addressautocomplete': {
		title: 'Address Autocomplete',
		description: 'Automatically suggest addresses as users start typing. Powered by Google Maps, your own API key is required to use this integration.',
		featureCode: 'addressautocomplete',
		illustration: 'address-autocomplete',
		plan: 'pro'
	},
	'createentries': {
		title: 'Auto-Create Entries',
		description: 'Automatically create and prefill new entries to build powerful multi-form workflows.',
		featureCode: 'createentriesfromactions',
		illustration: 'create-entries',
		plan: 'team'
	},
	'cognitoformsapi': {
		title: 'Cognito Forms API',
		description: '<p>Integrate and connect your apps to your forms with the Cognito&nbsp;Forms&nbsp;API.</p>',
		featureCode: 'cognitoformsapi',
		illustration: 'api',
		plan: 'pro',
		rawHtml: true
	},
	'guestaccess': {
		title: 'Guest Access',
		description: 'Enable <a class="text-link underline" href="https://www.cognitoforms.com/support/501/workflow/guest-access">Guest Access</a> to allow people outside your organization to securely sign in and view their entries, submit forms, and track their progress in one place.',
		featureCode: 'guestaccess',
		illustration: 'guest-access',
		plan: 'team',
		rawHtml: true,
		priority: true
	},
	'guestaccess-legacy': {
		title: 'Guest Access',
		description: 'Enable <a class="text-link underline" href="https://www.cognitoforms.com/support/501/workflow/guest-access">Guest Access</a> to allow people outside your organization to securely sign in and view their entries, submit forms, and track their progress in one place.',
		featureCode: 'guestaccess',
		illustration: 'person-field',
		plan: 'team',
		rawHtml: true
	},
	'branding': {
		title: 'Remove Cognito Branding',
		description: 'Keep the focus on your forms and emails by removing Cognito Forms branding.',
		featureCode: 'branding',
		illustration: 'theme',
		plan: 'pro',
		buttonText: 'Upgrade to Pro',
		balanceDescription: true,
		checkoutPlan: 'Pro'
	},
	'orgappearance': {
		title: 'Customize Appearance',
		description: 'Deliver an on-brand experience for your team and clients. Customize the colors used in the interface and upload your logo to match your company\'s branding.',
		featureCode: 'appearance',
		illustration: 'theme',
		plan: 'enterprise'
	},
	'organizationauditing': {
		title: 'Audit Log',
		description: 'Know the history of your organization\'s forms, folders, and users. Easily filter and export detailed reports for compliance and&nbsp;accountability.',
		featureCode: 'organizationauditing',
		illustration: 'activity-log',
		plan: null,
		rawHtml: true
	},
	'filesync': {
		title: 'Sync Files to Cloud Storage',
		description: `<p class="my-4">Automatically send uploaded files from your forms to your connected third-party storage provider.*</p>
			<div class="flex justify-center gap-4 my-4">
				<div class="flex flex-col items-center gap-3 p-4">
					<img src="${getIcon('GoogleDrive')}" width="35.82" height="32" alt="" />
					Google Drive
				</div>
				<div class="flex flex-col items-center gap-3 p-4">
					<img src="${getIcon('OneDrive')}" width="50" height="32" alt="" />
					OneDrive
				</div>
			</div>
			<p class="helptext my-4">*File transfers contribute to API usage.</p>`,
		featureCode: 'filesync',
		illustration: 'file-uploads',
		plan: 'pro',
		rawHtml: true
	}
};
